import { CareerSiteFiltersOption } from 'api-clients/monolith';
import React from 'react';

import { SearchBarGroup } from 'components/search-bar-group';
import { Skeleton } from 'components/ui/skeleton';

interface HomeSearchProps {
  scrollToJobs: () => void;
  radiusOptions: CareerSiteFiltersOption[];
}

export function HomeSearch({ scrollToJobs, radiusOptions }: HomeSearchProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 bg-gray-50 p-4">
      <div className="w-full max-w-5xl">
        <SearchBarGroup
          scrollToJobs={scrollToJobs}
          radiusOptions={radiusOptions}
        />
      </div>
    </div>
  );
}

HomeSearch.Skeleton = function HomeSearchSkeleton() {
  return <Skeleton className="h-full w-full" />;
};
